/* Gerber header: dropdowns, mobile drawer, predictive search. Vanilla, delegated, no dependencies. */
(function () {
  if (window.gerberHeaderReady) return;
  window.gerberHeaderReady = true;

  var doc = document;
  var root = doc.documentElement;
  var FOCUSABLE = 'a[href], button:not([disabled]), summary, input:not([type="hidden"])';
  var closeTimer;
  var lastFocus = null;
  var searchTimer;
  var searchAbort;

  /* ---------- Desktop dropdowns ---------- */
  function setItem(item, open) {
    var toggle = item.querySelector('.gh__nav-toggle');
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeItems(except) {
    var open = doc.querySelectorAll('.gh__nav-item.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) setItem(open[i], false);
    }
  }

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  doc.addEventListener('mouseover', function (e) {
    if (!canHover()) return;
    var item = e.target.closest('.gh__nav-item.has-children');
    if (!item) return;
    clearTimeout(closeTimer);
    closeItems(item);
    setItem(item, true);
  });

  doc.addEventListener('mouseout', function (e) {
    var item = e.target.closest('.gh__nav-item.has-children');
    if (!item || item.contains(e.relatedTarget)) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      setItem(item, false);
    }, 120);
  });

  doc.addEventListener('focusout', function (e) {
    var item = e.target.closest && e.target.closest('.gh__nav-item.is-open');
    if (item && !item.contains(e.relatedTarget)) setItem(item, false);
  });

  /* ---------- Drawer ---------- */
  function openDrawer(button) {
    var drawer = doc.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;
    lastFocus = button;
    drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    root.classList.add('gh-lock');
    var panel = drawer.querySelector('.gh__drawer-panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer(drawer, restoreFocus) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    root.classList.remove('gh-lock');
    var opener = doc.querySelector('[data-drawer-open][aria-controls="' + drawer.id + '"]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (restoreFocus !== false && lastFocus) lastFocus.focus();
  }

  /* ---------- Search ---------- */
  function closeResults(wrap) {
    var box = wrap.querySelector('[data-gh-results]');
    if (box) box.hidden = true;
  }

  function renderResults(wrap, query, products) {
    var box = wrap.querySelector('[data-gh-results]');
    var list = box.querySelector('.gh__results-list');
    var all = box.querySelector('.gh__results-all');
    var status = wrap.querySelector('[data-gh-status]');
    var frag = doc.createDocumentFragment();
    list.textContent = '';

    if (!products.length) {
      var empty = doc.createElement('li');
      empty.className = 'gh__results-empty';
      empty.textContent = wrap.dataset.emptyLabel;
      frag.appendChild(empty);
    }

    products.forEach(function (p) {
      var li = doc.createElement('li');
      var a = doc.createElement('a');
      a.className = 'gh__results-item';
      a.href = p.url;
      if (p.image) {
        var img = doc.createElement('img');
        img.className = 'gh__results-img';
        img.src = p.image;
        img.alt = '';
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var t = doc.createElement('span');
      t.textContent = p.title;
      a.appendChild(t);
      li.appendChild(a);
      frag.appendChild(li);
    });

    list.appendChild(frag);
    all.textContent = wrap.dataset.allLabel;
    all.href = wrap.querySelector('form').action + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
    all.hidden = !products.length;
    box.hidden = false;
    if (status) status.textContent = products.length ? wrap.dataset.allLabel : wrap.dataset.emptyLabel;
  }

  function runSearch(input) {
    var wrap = input.closest('[data-gh-search]');
    var query = input.value.trim();
    if (!wrap || wrap.dataset.predictive !== 'true') return;
    if (query.length < 2) return closeResults(wrap);
    if (searchAbort) searchAbort.abort();
    searchAbort = window.AbortController ? new AbortController() : null;

    fetch(
      wrap.dataset.predictiveUrl +
        '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
      searchAbort ? { signal: searchAbort.signal } : undefined
    )
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (input.value.trim() === query) {
          renderResults(
            wrap,
            query,
            items.map(function (p) {
              return { title: p.title, url: p.url, image: p.image };
            })
          );
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        closeResults(wrap);
      });
  }

  doc.addEventListener('input', function (e) {
    if (!e.target.matches('[data-gh-search-input]')) return;
    clearTimeout(searchTimer);
    var input = e.target;
    searchTimer = setTimeout(function () {
      runSearch(input);
    }, 250);
  });

  /* ---------- Clicks ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-drawer-open]');
    if (opener) return openDrawer(opener);

    if (t.closest('[data-drawer-close]')) {
      return closeDrawer(t.closest('[data-gh-drawer]'));
    }

    var toggle = t.closest('.gh__nav-toggle');
    if (toggle) {
      var item = toggle.closest('.gh__nav-item');
      var open = canHover() ? true : !item.classList.contains('is-open');
      closeItems(item);
      setItem(item, open);
      return;
    }

    if (!t.closest('.gh__nav-item')) closeItems();

    var links = t.closest('.gh__drawer a[href]');
    if (links) closeDrawer(links.closest('[data-gh-drawer]'), false);

    var searches = doc.querySelectorAll('[data-gh-search]');
    for (var i = 0; i < searches.length; i++) {
      if (!searches[i].contains(t)) closeResults(searches[i]);
    }
  });

  /* ---------- Keyboard ---------- */
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openItem = doc.querySelector('.gh__nav-item.is-open');
      if (openItem) {
        var focusInside = openItem.contains(doc.activeElement);
        setItem(openItem, false);
        if (focusInside) {
          var tg = openItem.querySelector('.gh__nav-toggle');
          if (tg) tg.focus();
        }
      }
      var drawer = doc.querySelector('[data-gh-drawer].is-open');
      if (drawer) closeDrawer(drawer);
      var wrap = e.target.closest && e.target.closest('[data-gh-search]');
      if (wrap) closeResults(wrap);
      return;
    }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var tgl = e.target.closest && e.target.closest('.gh__nav-toggle');
      var panelLink = e.target.closest && e.target.closest('.gh__panel');
      if (tgl) {
        var it = tgl.closest('.gh__nav-item');
        closeItems(it);
        setItem(it, true);
        var f = it.querySelector('.gh__panel a');
        if (f) { e.preventDefault(); f.focus(); }
      } else if (panelLink) {
        var links = Array.prototype.slice.call(panelLink.querySelectorAll('a'));
        var idx = links.indexOf(doc.activeElement) + (e.key === 'ArrowDown' ? 1 : -1);
        e.preventDefault();
        if (links[idx]) links[idx].focus();
      }
      return;
    }

    if (e.key !== 'Tab') return;
    var d = doc.querySelector('[data-gh-drawer].is-open');
    if (!d) return;
    var nodes = Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var panel = d.querySelector('.gh__drawer-panel');
    if (e.shiftKey && (doc.activeElement === first || doc.activeElement === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && doc.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });


  /* ---------- Sticky state ---------- */
  var stickyObserver;
  var ticking = false;

  function updateStuck() {
    ticking = false;
    var h = doc.querySelector('[data-gerber-header]');
    if (!h) return;
    var stuck = h.dataset.sticky === 'true' && h.parentElement.getBoundingClientRect().top <= 0 && window.scrollY > 4;
    h.classList.toggle('is-stuck', stuck);
  }

  function initSticky() {
    var h = doc.querySelector('[data-gerber-header]');
    if (stickyObserver) stickyObserver.disconnect();
    var on = !!h && h.dataset.sticky === 'true';
    root.classList.toggle('gh-sticky', on);
    if (!on) {
      root.style.removeProperty('--gh-sticky-h');
      if (h) h.classList.remove('is-stuck');
      return;
    }
    if (window.ResizeObserver) {
      stickyObserver = new ResizeObserver(function () {
        root.style.setProperty('--gh-sticky-h', h.offsetHeight + 'px');
      });
      stickyObserver.observe(h);
    }
    updateStuck();
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateStuck);
      }
    },
    { passive: true }
  );
  doc.addEventListener('shopify:section:load', initSticky);
  doc.addEventListener('shopify:section:unload', initSticky);
  initSticky();


  /* Theme editor: selecting a nav block opens the mobile drawer so the highlight is visible. */
  doc.addEventListener('shopify:block:select', function (e) {
    if (!e.target.closest || !e.target.closest('[data-gerber-header]')) return;
    var btn = doc.querySelector('[data-drawer-open]');
    if (btn && btn.offsetParent !== null) openDrawer(btn);
  });
  doc.addEventListener('shopify:block:deselect', function () {
    closeDrawer(doc.querySelector('[data-gh-drawer].is-open'), false);
  });

  /* Close the drawer when resizing to desktop. */
  window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
    if (mq.matches) closeDrawer(doc.querySelector('[data-gh-drawer].is-open'), false);
  });
})();
